export const INITIAL_ITEM_COUNT = 3
export const NUMBER_OF_ITEMS_TO_ADD = 3
